<app-breadcrumb [crumbPaths]="[{
    name: 'Home',
    path: '/home'
}, {
    name: 'Broker',
    path: '/broker',
    active: true
}]"></app-breadcrumb>
<app-page-header title="Broker" [buttons]="[{
        name: 'Add',
        eventName: 'add',
        cssClass: 'bg-primary'
    }]" (onButtonClick)="action($event)">
</app-page-header>
<app-page-content>
    <app-data-grid [dataSource]="dataSource" [config]="config" [dataLength]="dataSource.length" [isLoading]="isLoading"
        (dataActionEvent)="action($event)">
    </app-data-grid>
</app-page-content>

<app-slide-panel title="{{ this.editSelected ? 'Edit' : 'Add' }}" [(visible)]="addPanel" *ngIf="addPanel">
    <app-broker-add [user]="editSelected" (onDone)="onPopupclose()">
    </app-broker-add>
</app-slide-panel>